import React, { useMemo, useState } from 'react';
import { Box, Card, Typography, Chip, MenuItem, Select, Skeleton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Icon } from '@iconify/react';
import StageBadge, { stageStyles } from './StageBadge';

import { MONTHS } from '../../../../../utils/constants/daysConst';
import { OGAMilestoneAchievmentTable } from '../utils/OGAMilestoneTableHeader';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';
import GlobalTableNoPagination from '../../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

export default function MileStoneAchievmentTable({ loading, responseData }) {
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const rows = useMemo(() => {
    const milestones = responseData?.data?.milestones || [];

    return milestones.map((item, index) => {
      const stageStyle = stageStyles[item.currentStage] || {};
      return {
        id: index,
        name: item.oga,
        milestone: (
          <Chip
            label={`${stageStyle.emoji || ''} ${item.currentStage}`}
            sx={{
              background: stageStyle.bg || '#ccc',
              color: '#000',
              fontWeight: 600,
              my: 0.7,
            }}
          />
        ),
        achievementDate: item.achievementDate,
        eligibleDate: item.eligibleDate,
      };
    });
  }, [responseData]);

  const noDataFound = rows.length === 0;
  const formattedColumns = OGAMilestoneAchievmentTable;

  return (
    <Card sx={{ borderRadius: 2, overflow: 'hidden', mt: 4 }}>
      {/* 🔵 Header (same as yours) */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'linear-gradient(90deg, #416fee, #a855f7)',
          color: '#fff',
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Icon icon="cil:badge" width="18" height="18" />
          <Typography fontWeight={600}>Milestone Achievements</Typography>
          <Chip
            label={loading ? 'Loading...' : `${rows.length} Results`}
            size="small"
            sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }}
          />{' '}
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <FilterListIcon />

          {/* <Select
            size="small"
            defaultValue={0}
            sx={{
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: 2,
              '& .MuiSvgIcon-root': { color: '#fff' },
            }}
          >
            {MONTHS.map((month) => (
              <MenuItem key={month.id} value={month.id}>
                {month.name.charAt(0).toUpperCase() + month.name.slice(1)}
              </MenuItem>
            ))}
          </Select> */}
        </Box>
      </Box>
      {loading ? (
        // 🔁 TABLE SKELETON
        <Box sx={{ p: 2 }}>
          {[...Array(5)].map((_, i) => (
            <Box key={i} sx={{ display: 'flex', gap: 2, mb: 1 }}>
              <Skeleton width="20%" height={30} />
              <Skeleton width="20%" height={30} />
              <Skeleton width="20%" height={30} />
              <Skeleton width="20%" height={30} />
            </Box>
          ))}
        </Box>
      ) : noDataFound ? (
        // ❌ NO DATA
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30vh',
          }}
        >
          <NoDataFound />
        </Box>
      ) : (
        // ✅ TABLE
        <GlobalTableNoPagination
          rowUniqueId="name"
          headers={formattedColumns}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={rows}
        />
      )}
    </Card>
  );
}
